import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCorner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 11,
	viewBox: "0 0 9 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.77099 11C8.77099 11 2.85012 11 1.34146 11C-0.167207 11 -0.515898 9.51685 0.877137 8.0337C2.27017 6.55055 8.2557 1.6067 8.77099 0.123551C9.28627 -1.3596 8.77099 11 8.77099 11Z",
		fill: "currentColor"
	})
});
export default SvgCorner;
